/**
 * Extracts the domain from an email address.
 * @param email - The email address to extract domain from
 * @returns The domain part of the email, or empty string if invalid
 */
export const extractDomainFromEmail = (email: string): string => {
  const atIndex = email.indexOf('@');
  if (atIndex === -1 || atIndex === email.length - 1) {
    return '';
  }
  return email.substring(atIndex + 1);
};

/**
 * Formats a date string to a locale-specific string representation.
 * @param dateString - ISO date string or date-compatible string
 * @returns Formatted date string (e.g., "12/25/2023, 3:30:00 PM")
 */
export const formatDate = (dateString: string): string => {
  return new Date(dateString).toLocaleString();
};

/**
 * Formats an object to a pretty-printed JSON string.
 * Handles errors gracefully by falling back to String conversion.
 * @param obj - Object to format as JSON
 * @returns Pretty-printed JSON string with 2-space indentation
 */
export const formatJSON = (obj: any): string => {
  try {
    return JSON.stringify(obj, null, 2);
  } catch {
    return String(obj);
  }
};
